import { 
    ADD_ALERT,
    CREATE_AGREEMENT,
    FETCH_ALL_AGREEMENT,
    UPDATE_AGREEMENT,
    DELETE_AGREEMENT,
    ADD_AGREEMENT_TO_CARDETAIL,
    SEARCH_AGREEMENTS
} from './types';
import shortId from "shortid";
import sleektrading from "../apis/sleektrading"

export const createAgreement = (values) => dispatch => {
    sleektrading.post('/agreements', values)
        .then(response => {
            if(response.data.code == 201) {
                dispatch({
                    type:ADD_AGREEMENT_TO_CARDETAIL,
                    payload:response.data.data,
                });
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            } else {
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            }
    }).catch(error => {
        dispatch({
                type:ADD_ALERT,
                payload:{
                key:shortId.generate(),
                status:'error',
                message:error.response.data.message,
                errors:error.response.data.errors
            }
        });
    });
}

export const fetchAllAgreements= (pageNumber) => async dispatch => {
    const {data} = await sleektrading.get(`/agreements?page=${pageNumber}`);
    
    if(data.code == 201){
        dispatch({
            type: FETCH_ALL_AGREEMENT,
            payload: data.data
        });
    }
}

export const updateAgreementInfo = (values) => dispatch => {
    sleektrading.post('/accounts/edit', values)
        .then(response => {
            if(response.data.code == 201) {
                dispatch({
                    type: UPDATE_ACCOUNT_INFO,
                    payload: response.data.data
                });
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            } else {
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            }
    }).catch(error => {
        dispatch({
                type:ADD_ALERT,
                payload:{
                key:shortId.generate(),
                status:'error',
                message:error.response.data.message,
                errors:error.response.data.errors
            }
        });
    });
}

export const printAgreement = (params) => dispatch => {
    const config = { responseType: 'blob', Accept:'application/pdf' };   
    sleektrading.post('/agreements/print', params, config)
    .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const date = new Date().getTime()+'agreement.pdf';
        link.setAttribute('download', date);
        document.body.appendChild(link);
        link.click();
        const blob = new Blob([response.data], {
            type: "application/pdf",
        });
    });
}

export const deleteAgreement= (agreement_id) => async dispatch => {
    sleektrading.delete(`/agreements/${agreement_id}`)
    .then(response => {
        if(response.data.code == 200) {
            dispatch({
                type:DELETE_AGREEMENT, 
                payload:agreement_id
            });
            dispatch({
                type: ADD_ALERT,
                payload: {
                    key: shortId.generate(),
                    status: 'success',
                    color:'info',
                    message: response.data.message,
                    errors: {}
                }
            });
        } else {
            dispatch({
                type: ADD_ALERT,
                payload: {
                    key: shortId.generate(),
                    status: 'success',
                    color:'info',
                    message: response.data.message,
                    errors: {}
                }
            });
        }
    }).catch(error => {
        dispatch({
            type:ADD_ALERT,
            payload:{
            key:shortId.generate(),
            status:'error',
            message:error.response.data.message,
            errors:error.response.data.errors
        }
    });
    });
}

export const searchAgreements = (values) => dispatch => {
    sleektrading.post('/search/agreements', values)
        .then(response => {
            if(response.data.code == 201) {
                dispatch({
                    type: SEARCH_AGREEMENTS,
                    payload: response.data.data
                });
            } else {
                dispatch({
                    type: ADD_ALERT,
                    payload: {
                        key: shortId.generate(),
                        status: 'success',
                        color:'info',
                        message: response.data.message,
                        errors: {}
                    }
                });
            }
    }).catch(error => {
        dispatch({
                type:ADD_ALERT,
                payload:{
                key:shortId.generate(),
                status:'error',
                message:error.response.data.message,
                errors:error.response.data.errors
            }
        });
    });
}


